define.alias("shared/components/shared/mobile/drawer/image-card", "calendar/components/shared/mobile/drawer/image-card");